import { render, staticRenderFns } from "./FilterMail.vue?vue&type=template&id=1028fdfc&scoped=true"
import script from "./FilterMail.vue?vue&type=script&lang=js"
export * from "./FilterMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1028fdfc",
  null
  
)

export default component.exports